import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { getTextFiguritas } from "../utils/figuritas";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SharePill({ estado }) {
  const figuritas = useSelector((state) => state.figuritasReducer.figuritas);

  const textRepes = useMemo(() => {
    return getTextFiguritas(figuritas.album, estado);
  }, [figuritas]);

  const copyRepes = (e) => {
    e.stopPropagation();
    toast.success("Listado copiado.", {
      theme: "colored",
    });
    navigator.clipboard.writeText(textRepes);
  };

  return (
    <>
      <ToastContainer
        position="top-left"
        limit={1}
        autoClose={1000}
        style={{ width: "20rem" }}
      />
      <span className={`sharePill`} onClick={(e) => copyRepes(e)}>
        Copiar
        <FontAwesomeIcon icon={faCopy} />
      </span>
    </>
  );
}
